var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rt"},[_c('div',{ref:"Rtbottom",staticClass:"rt-bottom",style:({ width: '100%', height: '100%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }